import { useTranslations } from '@vocab/react';
import { Text, TextLink } from 'braid-design-system';
import React from 'react';

import { useConfig } from 'src/hooks/useConfig';
import { getPhoneNumber } from 'src/modules/localisation/customerService';
import { isSiteAnz } from 'src/siteConfig';
import { getContactUsUrl } from 'src/utils/routes';

import translations from '../.vocab';

export const CustomerServiceMessage = () => {
  const { site, urlResolver } = useConfig();
  const { t } = useTranslations(translations);

  const isAnz = isSiteAnz(site);
  const csPhoneNumber = getPhoneNumber(site);
  const contactUsUrl = getContactUsUrl(urlResolver);

  const AnzMessage = () => (
    <Text>
      {t(
        'If the problem persists please call Customer Service on phone number link',
        {
          CustomerServicePhoneNumber: () => (
            <TextLink key="csphone" href={`tel:${csPhoneNumber}`}>
              {csPhoneNumber}
            </TextLink>
          ),
        },
      )}
    </Text>
  );

  const AsiaMessage = () => (
    <Text>
      {t('If the problem persists please contact Customer Service', {
        Link: (children) => (
          <TextLink key="cslink" href={`${contactUsUrl}`}>
            {children}
          </TextLink>
        ),
      })}
    </Text>
  );

  return isAnz ? <AnzMessage /> : <AsiaMessage />;
};
